import { FC, SVGAttributes } from 'react';

const Coins: FC<SVGAttributes<SVGElement>> = (props) => {
    return (
        <svg {...props} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M13.1672 20.969C11.7538 21.8081 10.1013 22.1525 8.47038 21.9479C6.83951 21.7433 5.32324 21.0013 4.16094 19.8391C2.99864 18.6769 2.25653 17.1607 2.05177 15.5299C1.84701 13.899 2.19126 12.2464 3.03018 10.833M14.0002 18C16.1219 18 18.1567 17.1571 19.657 15.6569C21.1573 14.1566 22.0002 12.1217 22.0002 10C22.0002 7.87827 21.1573 5.84344 19.657 4.34315C18.1567 2.84285 16.1219 2 14.0002 2C11.8784 2 9.84362 2.84285 8.34333 4.34315C6.84303 5.84344 6.00018 7.87827 6.00018 10C6.00018 12.1217 6.84303 14.1566 8.34333 15.6569C9.84362 17.1571 11.8784 18 14.0002 18Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M13.5441 14.007C13.7227 14.396 14.2758 14.3954 14.4535 14.0059L15.56 11.58L18.0044 10.4573C18.3939 10.2784 18.3925 9.72453 18.0023 9.54753L15.56 8.44L14.4539 6.00093C14.2767 5.61012 13.7219 5.60945 13.5437 5.99983L12.43 8.44L9.99435 9.54776C9.60472 9.72497 9.60339 10.2779 9.99216 10.457L12.43 11.58L13.5441 14.007Z"
                fill="currentColor"
            />
        </svg>
    );
};

export default Coins;
